<template lang="html">

    <div class="row">

        <div class="col-md-12 col-lg-12 col-xl-6" v-if="showDatesPicker">
            <label class="mr-3 d-inline-flex">Dates</label>
            <!-- <datepicker input-class="bg-lightest w-100" v-model="group.dateTo" format="dd/MM/yyyy" @selected="setDateTo($event, group)" :disabled-picker="!group.isEditing || group.isEditing == false"></datepicker> -->
            <!-- :disabled="!group.isEditing || group.isEditing == false" -->
            <date-picker-new
            class="dateRangePicker"
            v-model="groupDateRange"
            @input="datesChanged($event, group)"
            :range="true"
            :disabled="!group.isEditing || group.isEditing == false"
            :enableClear="false"
            :clearOutside="true"
            :showFromTo="false"></date-picker-new>
        </div>

        <div class="col-md-12 col-lg-12 col-xl-6">
            <label class="full">
                Duration
            </label>
            <duration-picker v-model="group.duration" :disabled="!group.isEditing || group.isEditing == false" @input="groupChanged()"></duration-picker>
        </div>

        <div class="col-sm-12 position-relative" v-for="schedule, index in group.schedules">

            <i  class="ico-delete fs-large medium pointer removeSchedule" :class="{'opacity-50 notAllowed':!group.isEditing || group.isEditing == false && (schedule.id && schedule.id  !== null)}" @click="removeSchedule(group, index, schedule)"></i>

            <div class="col-sm-12 panel bg-lighter py-0 px-4">

                <div class="row my-3">

                    <div class="col-lg-12 col-xl-3 mb-2">
                        <label class="mr-3 d-inline-flex">Starts at</label>
                        <timepicker @change="setStartTime($event, schedule)" :defaultTime="fetchDefaultScheduleStartTime(schedule)" :availableHours="durationHourSlots" :disabled="!group.isEditing || group.isEditing == false"></timepicker>
                    </div>




                    <div class="col-lg-12 col-xl-9">
                        <div class="d-flex justify-content-between">
                        <label class="mr-3 d-inline-flex">Repeat weekly</label>
                        </div>
                        <div class="d-flex align-items-center flex-wrap">
                            <week-day-picker :disabled="(!group.isEditing || group.isEditing == false )" v-model="schedule.repeatsAtWeekDays" @change="productAcivateUpdateFlag('scheduleWeekdays')"></week-day-picker>
                        </div>

                    </div>


                </div>

            </div>
        </div>

        <div v-if="!group.readOnly" class="col-sm-12 mt-3 fs-small bold" :class="{'opacity-50 notAllowed':!group.isEditing || group.isEditing == false}">
            <span @click="addRepetition(group)" class="pointer"><i class="ico-add fs-smallest add-circle color-1"></i> Add time</span>
        </div>

    </div>
</template>

<script>
import DatePickerNew from 'vue-date'
import DurationPicker from './DurationPicker'
import Timepicker from '@/tools/Timepicker'
import WeekDayPicker from './WeekDayPicker'

export default {
    created: function () {
        this.durationHourSlots = this.leadingZeros(_.range(0, 25));
    },
    props: {
        group: {
            type: Object,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
    },
    data: function () {
        return {
            durationHourSlots: null,
            showDatesPicker: true
        }
    },
    computed: {
        groupDateRange: {
            get(group) {
                return [
                    this.group.dateFrom,
                    this.group.dateTo
                ]
            },
            set(newVal) {
                this.group.dateFrom = newVal[0]
                this.group.dateTo = newVal[1]

            }
        },
    },
    methods: {
        fetchDefaultScheduleStartTime: function(schedule) {
            if (schedule.startTime !== undefined && schedule.startTime) {
                // Transform in array and remove seconds

                let parts = schedule.startTime.split(':');
                let time = [parts[0], parts[1]];

                return time;
            }

            return this.defaultScheduleStartTime;
        },
        removeSchedule: function(group, index, schedule) {
            if(!group.isEditing || group.isEditing == false && (schedule.id && schedule.id  !== null)){
                return false
            }

            if(group.schedules.length == 1){
                this.$dialog.alert('\
                <div class="fs-larg font-weight-600 mb-4">Unable to delete this schedule.</div>\
                <div>You need to have at least one repetition, if you need to delete this one please create another one before.</div>', {
                    okText:'Ok'
                })
                .then(function () {

                })
                .catch(function () {
                });
                return false
            }

            this.$dialog.confirm('\
            <div class="fs-larg font-weight-600 mb-4">Delete schedule?</div>\
            <div>If this schedule has any reservations, those will <span class="underlined bold color-6">be canceled!</span></div>')
            .then(function () {
                group.schedules.splice(index, 1)
                this.$set(group, 'schedules', group.schedules)
            })
            .catch(function () {
            });

        },
        setStartTime: function(event, schedule) {
            this.groupChanged()
            schedule.startTime = event + ':00';
        },
        addRepetition: function(group) {
            if(!group.isEditing || group.isEditing == false){
                return false
            }

            let lastScheduleFromGroup = JSON.parse(JSON.stringify(group.schedules[group.schedules.length - 1]))
            lastScheduleFromGroup.id = null
            group.schedules.push(lastScheduleFromGroup)
        },
        groupChanged:function () {
            this.$emit('update', this.group)
        },
        datesChanged: function (dates, group) {
            this.groupChanged()
            let newDateFrom = dates[0];
            let newDateTo = dates[1];
            let oldDateFrom = null;
            let oldDateTo = null;

            // if is an existing group
            if(group.id){
                oldDateFrom = group.backupGroup.dateFrom
                oldDateTo = group.backupGroup.dateTo

                if(
                    moment(newDateFrom).isAfter(moment(oldDateFrom)) ||
                    moment(newDateTo).isBefore(moment(oldDateTo))
                ){
                    this.$dialog.confirm('Some events might be lost, proceed?', {okText: 'Yes', cancelText: 'No'})
                    .then(() => {

                    })
                    .catch(() => {
                        group.dateFrom = oldDateFrom
                        group.dateTo = oldDateTo

                        // workaround to reload the timepicker therefore showing the correct selected dates
                        this.showDatesPicker = false
                        setTimeout(() => {
                            this.showDatesPicker = true

                        }, 1);

                    });
                }
            }

        },
        setDateFrom: function(event, schedule) {
            let newDateFrom = event
            let oldDateFrom = JSON.parse(JSON.stringify(schedule.dateFrom));
            let dateTo = schedule.dateTo
            let vm = this


            //this will display a messagem informing the user that some event might be lost, if the date From increasses
            if(schedule.id != null && moment(newDateFrom).isAfter(moment(oldDateFrom))){
                this.$dialog.confirm('By changing dates, some events might be lost. Do you want to proceed?', {okText: 'Yes', cancelText: 'No'})
                .then(function () {
                    vm.$set(schedule, 'dateFrom', moment(newDateFrom).format('YYYY-MM-DD'))
                })
                .catch(function () {
                    vm.$set(schedule, 'dateFrom', moment(oldDateFrom).format('YYYY-MM-DD'))
                });
            } else {
                // if the date change does not decrease the number of events then all good to go
                this.$set(schedule, 'dateFrom', moment(newDateFrom).format('YYYY-MM-DD'))

            }

        },
    },
    components:{
        DatePickerNew,
        DurationPicker,
        Timepicker,
        WeekDayPicker
    }
}
</script>

<style lang="scss" scoped>
//remove schedule
.removeSchedule{
    position: absolute;
    top: 1.5em !important;
    right: 1em !important;
    z-index: 1;
}
</style>



// WEBPACK FOOTER //
// ProductScheduleGroupTimeDates.vue?13e003f6